import React from "react";

function ListAssistants() {
  return (
      <div className="row">
        <div className="col-md-6 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Assistants</h4>
              <div className="d-flex align-items-center pb-3 border-bottom">
                <img
                  className="img-sm rounded-circle"
                  src="../../../../images/faces/face5.jpg"
                  alt="profile"
                />
                <div className="ml-3">
                  <h6 className="mb-1">Stella Davidson</h6>
                  <small className="text-muted mb-0">
                    <i className="mdi mdi-map-marker mr-1"></i>New York City,
                    USA
                  </small>
                  <div className="template-demo">
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic example"
                    >
                      <button type="button" className="btn btn-primary">
                        1
                      </button>
                      <button type="button" className="btn btn-primary">
                        2
                      </button>
                      <button type="button" className="btn btn-primary">
                        3
                      </button>
                      <button type="button" className="btn btn-primary">
                        4
                      </button>
                      <button type="button" className="btn btn-primary">
                        5
                      </button>
                    </div>
                  </div>
                </div>
                <i className="mdi mdi-check-circle-outline font-weight-bold ml-auto px-1 py-1 text-info mdi-24px"></i>
              </div>
              <div className="d-flex align-items-center py-3 border-bottom">
                <img
                  className="img-sm rounded-circle"
                  src="../../../../images/faces/face6.jpg"
                  alt="profile"
                />
                <div className="ml-3">
                  <h6 className="mb-1">Daniel Russel</h6>
                  <small className="text-muted mb-0">
                    <i className="mdi mdi-map-marker mr-1"></i>Florida, USA
                  </small>
                  <div className="template-demo">
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic example"
                    >
                      <button type="button" className="btn btn-primary">
                        1
                      </button>
                      <button type="button" className="btn btn-primary">
                        2
                      </button>
                      <button type="button" className="btn btn-primary">
                        3
                      </button>
                      <button type="button" className="btn btn-primary">
                        4
                      </button>
                      <button type="button" className="btn btn-primary">
                        5
                      </button>
                    </div>
                  </div>
                </div>
                <i className="mdi mdi-plus-circle-outline font-weight-bold ml-auto px-1 py-1 text-success mdi-24px"></i>
              </div>
              <div className="d-flex align-items-center py-3 border-bottom">
                <img
                  className="img-sm rounded-circle"
                  src="../../../../images/faces/face7.jpg"
                  alt="profile"
                />
                <div className="ml-3">
                  <h6 className="mb-1">Bruno King</h6>
                  <small className="text-muted mb-0">
                    <i className="mdi mdi-map-marker mr-1"></i>Arkansas, USA
                  </small>
                  <div className="template-demo">
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic example"
                    >
                      <button type="button" className="btn btn-primary">
                        1
                      </button>
                      <button type="button" className="btn btn-primary">
                        2
                      </button>
                      <button type="button" className="btn btn-primary">
                        3
                      </button>
                      <button type="button" className="btn btn-primary">
                        4
                      </button>
                      <button type="button" className="btn btn-primary">
                        5
                      </button>
                    </div>
                  </div>
                </div>
                <i className="mdi mdi-check-circle-outline font-weight-bold ml-auto px-1 py-1 text-info mdi-24px"></i>
              </div>
              <div className="d-flex align-items-center py-3 border-bottom">
                <img
                  className="img-sm rounded-circle"
                  src="../../../../images/faces/face8.jpg"
                  alt="profile"
                />
                <div className="ml-3">
                  <h6 className="mb-1">David Moore</h6>
                  <small className="text-muted mb-0">
                    <i className="mdi mdi-map-marker mr-1"></i>Arizon, USA
                  </small>
                  <div className="template-demo">
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic example"
                    >
                      <button type="button" className="btn btn-primary">
                        1
                      </button>
                      <button type="button" className="btn btn-primary">
                        2
                      </button>
                      <button type="button" className="btn btn-primary">
                        3
                      </button>
                      <button type="button" className="btn btn-primary">
                        4
                      </button>
                      <button type="button" className="btn btn-primary">
                        5
                      </button>
                    </div>
                  </div>
                </div>
                <i className="mdi mdi-plus-circle-outline font-weight-bold ml-auto px-1 py-1 text-success mdi-24px"></i>
              </div>
              <div className="d-flex align-items-center pt-3">
                <img
                  className="img-sm rounded-circle"
                  src="../../../../images/faces/face9.jpg"
                  alt="profile"
                />
                <div className="ml-3">
                  <h6 className="mb-1">Rafell John</h6>
                  <small className="text-muted mb-0">
                    <i className="mdi mdi-map-marker mr-1"></i>Alaska, USA
                  </small>
                  <div className="template-demo">
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="Basic example"
                    >
                      <button type="button" className="btn btn-primary">
                        1
                      </button>
                      <button type="button" className="btn btn-primary">
                        2
                      </button>
                      <button type="button" className="btn btn-primary">
                        3
                      </button>
                      <button type="button" className="btn btn-primary">
                        4
                      </button>
                      <button type="button" className="btn btn-primary">
                        5
                      </button>
                    </div>
                  </div>
                </div>
                <i className="mdi mdi-plus-circle-outline font-weight-bold ml-auto px-1 py-1 text-success mdi-24px"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
}

export { ListAssistants };
